import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import localsearchLogo from '../../assets/branding/localsearch-logo.jpg';
import config from '../../../src/client/config';

const { urlRoot } = config;

const Meta = ({ titleName, canonical, letter }) => {
  const rootCanonical = useMemo(
    () => `${canonical.replace(/\/categories\/.$/, `/categories`)}`,
    [canonical]
  );
  const getLetterIndex = value => {
    const alphabet = [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'y',
      'z',
    ];
    const letterIndex = alphabet.indexOf(value);
    const prevLetter = alphabet[letterIndex - 1];
    const nextLetter = alphabet[letterIndex + 1];
    return {
      letterIndex,
      prevLetter,
      nextLetter,
    };
  };

  const { letterIndex, prevLetter, nextLetter } = getLetterIndex(letter);

  const description =
    "Australia's #1 local business directory. Since 1993, Localsearch has been the best print &amp; online advertising solution for your business.";

  return (
    <Helmet>
      <title>{`${titleName} | Localsearch`}</title>
      <meta name="description" content={description} />
      <meta name="COPYRIGHT" content="Localsearch" />
      <meta name="AUTHOR" content="Localsearch" />
      <meta name="RESOURCE-TYPE" content="DOCUMENT" />
      <meta name="DISTRIBUTION" content="GLOBAL" />
      <meta name="RATING" content="GENERAL" />
      <meta property="og:title" content={titleName} />
      <meta property="og:type" content="company" />
      <meta property="og:image" content={`${urlRoot}/${localsearchLogo}`} />
      <meta property="og:url" content={urlRoot} />
      <meta property="og:site_name" content="Localsearch" />
      <meta property="og:description" content={description} />
      <link rel="canonical" href={`${urlRoot}${canonical}`} />
      {letterIndex > 0 && letterIndex < 25 && prevLetter ? (
        <link rel="prev" href={`${rootCanonical}/${prevLetter}`} />
      ) : (
        ''
      )}
      {letterIndex > 0 && letterIndex < 25 && nextLetter ? (
        <link rel="next" href={`${rootCanonical}/${nextLetter}`} />
      ) : (
        ''
      )}
      {letterIndex > 24 ? <link rel="prev" href={`${rootCanonical}/y`} /> : ''}
      {!letterIndex ? <link rel="next" href={`${rootCanonical}/b`} /> : ''}
    </Helmet>
  );
};

Meta.propTypes = {
  titleName: PropTypes.string,
  canonical: PropTypes.string,
  letter: PropTypes.string,
};

Meta.defaultProps = {
  titleName: '',
  canonical: '',
  letter: '',
};

export default Meta;
